var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuvolaDiPunti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94492 0.474609C1.27744 0.474609 0.736328 1.01572 0.736328 1.6832V2.71914C0.736328 3.38663 1.27744 3.92773 1.94492 3.92773H2.11758V8.07148H1.94492C1.27744 8.07148 0.736328 8.61257 0.736328 9.28008V10.316C0.736328 10.9835 1.27744 11.5246 1.94492 11.5246H2.98086C3.64834 11.5246 4.18945 10.9835 4.18945 10.316V10.1434H8.3332V10.316C8.3332 10.9835 8.8743 11.5246 9.5418 11.5246H10.5777C11.2452 11.5246 11.7863 10.9835 11.7863 10.316V9.28008C11.7863 8.61258 11.2452 8.07148 10.5777 8.07148H10.4051V3.92773H10.5777C11.2452 3.92773 11.7863 3.38662 11.7863 2.71914V1.6832C11.7863 1.01571 11.2452 0.474609 10.5777 0.474609H9.5418C8.87429 0.474609 8.3332 1.01573 8.3332 1.6832V1.85586H4.18945V1.6832C4.18945 1.01571 3.64834 0.474609 2.98086 0.474609H1.94492ZM4.17721 2.8918C4.1015 3.42111 3.68282 3.83978 3.15352 3.91549V8.08372C3.68282 8.15943 4.1015 8.5781 4.17721 9.10742H8.34544C8.42115 8.5781 8.83982 8.15943 9.36914 8.08372V3.9155C8.83982 3.83978 8.42115 3.4211 8.34544 2.8918H4.17721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuvolaDiPunti);
export default __webpack_public_path__ + "static/media/NuvolaDiPunti.7a2fdb05cc9f64ed5ee6f317c0b0acf8.svg";
export { ForwardRef as ReactComponent };